import React from "react";
import {
  Flex,
  Typography,
  Row,
  Col,
  SelectField,
  InputField,
  Divider,
  Button,
  Gap,
  FabButton,
} from "../../../../ppui";
import {
  ContentBody,
  ContentLayout,
  PhotoIcon,
  PhotoUpload,
} from "../../../../pages/style";
import { TbCamera, TbEditCircle, TbEye, TbEyeOff, TbUserEdit } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import useAddOrganizationService from "./add-organization-service";
import { PasswordToggleIcon } from "../../login/style";
import { INDUSTRY_TYPE, ORGANIZATION_CATEGORY } from "./add-organization-constant";

function AdminOrganizationAdd({ openSnackbar }) {
  const route = useNavigate();
  const {
    handleChange,
    orgData,
    handleBlurFn,
    errors,
    togglePasswordVisibility,
    showPassword,
    showConfirmPassword,
    allState,
    handleSubmit,
    toggleConfirmPasswordVisibility,

    fileInputRef,
    previewURL,
    setSelectedFile,
    setPreviewURL,
    setOrgProfile,
  } = useAddOrganizationService({openSnackbar});
  return (
    <>
      <ContentLayout>
        <ContentBody Padding>
          <Typography variant="h5">Basic Information</Typography>
          <Row>
            <Col sm={12} md={"auto"}>
              <PhotoUpload
                            onClick={() => {
                              if (fileInputRef.current) {
                                fileInputRef.current.click();
                              }
                            }}
                          >
                            {!previewURL &&
                              <TbUserEdit />
                            }
                            <input
                              type="file"
                              id="image"
                              name="image"
                              onChange={(event) => {
                                const file = event.target.files[0]; // Get the selected file
                                if (file) {
                                  // Check if the file size is within the 2 MB limit
                                  const maxSizeInBytes = 2 * 1024 * 1024; // 2 MB in bytes
                                  if (file.size > maxSizeInBytes) {
                                    openSnackbar({
                                      message: "File size should not exceed 2 MB.",
                                      color: "danger",
                                    });
              
              
                                    return; // Stop if file is too large
                                  }
                                  const allowedTypes = ["image/jpeg", "image/jpg"];
              
                                  if (!allowedTypes.includes(file.type)) {
                                    openSnackbar({
                                      message: "Only JPG files are allowed.",
                                      color: "danger",
                                    });
                                    return; // Stop if the file type is not allowed
                                  }
              
                                  setSelectedFile(file);
                                  setPreviewURL(URL.createObjectURL(file)); // Create a preview URL
              
                                  setOrgProfile((prevUser) => ({
                                    ...prevUser,
                                    logo: file,
                                  }));
                                }
                              }}
                              ref={fileInputRef}
                              accept=".jpg, image/jpeg"
                              hidden
                            />
                            {previewURL && <img src={previewURL} alt="" />}
                            <PhotoIcon>
                              <FabButton size="xs" variant="contained" color="primary" icon={previewURL ? <TbEditCircle /> : <TbCamera />} />
                            </PhotoIcon>
                          </PhotoUpload>
            </Col>
            <Col col-xs={"auto"}>
              <Row rowGap>
                <Col sm={12} md={6} lg={6} xxl={4}>
                  <InputField
                    fullWidth
                    required={true}
                    name="org_name"
                    label="Organization Name"
                    placeholder="Type Here"
                    value={orgData.org_name}
                    onChange={(e) => handleChange(e.target.value, "org_name")}
                    helperText={errors.org_name}
                    error={errors.org_name}
                    onBlur={(e) => handleBlurFn(e, "org_name")}
                  />
                </Col>
                <Col sm={12} md={6} lg={6} xxl={4}>
                  <InputField
                    fullWidth
                    required={true}
                    name="domain_name"
                    label="Domain Name"
                    type="text"
                    placeholder="Type Here"
                    value={orgData.domain_name}
                    onChange={(e) =>
                      handleChange(e.target.value, "domain_name")
                    }
                    helperText={errors.domain_name}
                    error={errors.domain_name}
                    onBlur={(e) => handleBlurFn(e, "domain_name")}
                  />
                </Col>
                <Col sm={12} md={6} lg={6} xxl={4}>
                  <InputField
                    fullWidth
                    name="phone"
                    required={true}
                    label="Phone"
                    type="tel"
                    placeholder="Type Here"
                    value={orgData.phone}
                    onChange={(e) => handleChange(e.target.value, "phone")}
                    helperText={errors.phone}
                    error={errors.phone}
                    onBlur={(e) => handleBlurFn(e, "phone")}
                  />
                </Col>
                <Col sm={12} md={6} lg={6} xxl={4}>
                  <InputField
                    fullWidth
                    label="Landline"
                    type="tel"
                    placeholder="Type Here"
                    name="landline"
                    value={orgData.landline}
                    onChange={(e) => handleChange(e.target.value, "landline")}
                    helperText={errors.landline}
                    error={errors.landline}
                    onBlur={(e) => handleBlurFn(e, "landline")}
                  />
                </Col>
                <Col sm={12} md={6} lg={6} xxl={4}>
                  <InputField
                    fullWidth
                    label="Email"
                    required={true}
                    type="email"
                    placeholder="Type Here"
                    valueSinc={true}
                    name="email"
                    value={orgData.email}
                    onChange={(e) => handleChange(e.target.value, "email")}
                    helperText={errors.email}
                    error={errors.email}
                    onBlur={(e) => handleBlurFn(e, "email")}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Divider gap={20} />
          <Typography variant="h5">Organization Details</Typography>
          <Row rowGap>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <SelectField
                required
                fullWidth
                // registration_type
                label="Organization Category"
                options={ORGANIZATION_CATEGORY}
                defaultValue="fixed"
                placeholder="Select Here..."
                valueSinc={!!orgData.registration_type}
                onChange={(val) => handleChange(val, "registration_type")}
                error={errors.registration_type}
                helperText={errors.registration_type}
                onBlur={(e) => handleBlurFn(e, "registration_type")}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <SelectField
                fullWidth
                label="Industry Type"
                options={INDUSTRY_TYPE}
                defaultValue="fixed"
                placeholder="Select Here..."
                valueSinc={!!orgData.industry_type}
                onChange={(val) => handleChange(val, "industry_type")}
                error={errors.industry_type}
                helperText={errors.industry_type}
                onBlur={(e) => handleBlurFn(e, "industry_type")}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                fullWidth
                label="Organization PAN"
                placeholder="Type Here"
                type="tel"
                name="pan"
                value={orgData.pan}
                onChange={(e) => handleChange(e.target.value, "pan")}
                helperText={errors.pan}
                error={errors.pan}
                onBlur={(e) => handleBlurFn(e, "pan")}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                fullWidth
                label="Organization TAN"
                placeholder="Type Here"
                type="tel"
                name="tan_no"
                value={orgData.tan_no}
                onChange={(e) => handleChange(e.target.value, "tan_no")}
                helperText={errors.tan_no}
                error={errors.tan_no}
                onBlur={(e) => handleBlurFn(e, "tan_no")}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                fullWidth
                name="date_of_org"
                label="Date of Establishment"
                type="date"
                placeholder="Type Here"
                valueSinc
                value={orgData.date_of_org}
                onChange={(e) => handleChange(e.target.value, "date_of_org")}
                helperText={errors.date_of_org}
                error={errors.date_of_org}
                onBlur={(e) => handleBlurFn(e, "date_of_org")}
                onKeyDown={(e) => e.preventDefault()}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <SelectField
                required
                fullWidth
                label="Payment Type"
                name= "payment_type"
                options={[
                  { id: "salary", name: "Salary" },
                  { id: "wages", name: "Wages" },
                ]}
                defaultValue="fixed"
                placeholder="Select Here..."
                valueSinc={!!orgData.payment_type}
                onChange={(val) => handleChange(val, "payment_type")}
                error={errors.payment_type}
                helperText={errors.payment_type}
                onBlur={(e) => handleBlurFn(e, "payment_type")}
              />
            </Col>
          </Row>
          <Divider gap={20} />
          <Typography variant="h5">Organization Address</Typography>
          <Row rowGap>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                fullWidth
                label="Address"
                placeholder="Type Here"
                type="text"
                name="address"
                value={orgData.address}
                onChange={(e) => handleChange(e.target.value, "address")}
                helperText={errors.address}
                error={errors.address}
                onBlur={(e) => handleBlurFn(e, "address")}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                fullWidth
                label="City/District"
                placeholder="Type Here"
                type="text"
                name="city"
                value={orgData.city}
                onChange={(e) => handleChange(e.target.value, "city")}
                helperText={errors.city}
                error={errors.city}
                onBlur={(e) => handleBlurFn(e, "city")}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <SelectField
                fullWidth
                label="State"
                name="state"
                options={allState}
                placeholder="Type here..."
                defaultValue={orgData.state}
                valueSinc={!!orgData.state}
                onChange={(val) => handleChange(val, "state")}
                error={errors.state}
                helperText={errors.state}
                onBlur={(e) => handleBlurFn(e, "state")}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <SelectField
                // required
                fullWidth
                label="Country"
                options={[{ id: "option1", name: "India" }]}
                defaultValue="fixed"
                placeholder="Select Here..."
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                fullWidth
                label="Pincode"
                type="number"
                placeholder="Type Here"
                name="pincode"
                value={orgData.pincode}
                onChange={(e) => handleChange(e.target.value, "pincode")}
                helperText={errors.pincode}
                error={errors.pincode}
                onBlur={(e) => handleBlurFn(e, "pincode")}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                fullWidth
                label="Locality"
                placeholder="Type Here"
                type="text"
                name="locality"
                value={orgData.locality}
                onChange={(e) => handleChange(e.target.value, "locality")}
                helperText={errors.locality}
                error={errors.locality}
                onBlur={(e) => handleBlurFn(e, "locality")}
              />
            </Col>
            <Col sm={12} md={6} lg={4} xxl={3}>
              <InputField
                fullWidth
                label="Landmark"
                placeholder="Type Here"
                type="text"
                name="landmark"
                value={orgData.landmark}
                onChange={(e) => handleChange(e.target.value, "landmark")}
                helperText={errors.landmark}
                error={errors.landmark}
                onBlur={(e) => handleBlurFn(e, "landmark")}
              />
            </Col>
          </Row>
          <Divider gap={20} />
          <Typography variant="h5">Login Credential</Typography>
          <Flex direction="column" gap={20}>
            <Row rowGap>
              <Col lg={8} xxl={6}>
                <Row rowGap>
                  <Col sm={12} md={6}>
                    <InputField
                      fullWidth
                      label="Password"
                      required={true}
                      placeholder="Type Here"
                      type={showPassword ? "text" : "password"}
                      valueSinc={true}
                      prefix={
                        <PasswordToggleIcon
                          onClick={togglePasswordVisibility}
                          style={{ cursor: "pointer" }}
                        >
                          {showPassword ? <TbEyeOff /> : <TbEye />}
                        </PasswordToggleIcon>
                      }
                      name="password"
                      value={orgData.password}
                      onChange={(e) => handleChange(e.target.value, "password")}
                      helperText={errors.password}
                      error={errors.password}
                      onBlur={(e) => handleBlurFn(e, "password")}
                    />
                  </Col>
                  <Col sm={12} md={6}>
                    <InputField
                      fullWidth
                      required={true}
                      label="Confirm Password"
                      placeholder="Type Here"
                      type={showConfirmPassword ? "text" : "password"}
                      prefix={
                        <PasswordToggleIcon
                          onClick={toggleConfirmPasswordVisibility}
                          style={{ cursor: "pointer" }}
                        >
                          {showConfirmPassword ? <TbEyeOff /> : <TbEye />}
                        </PasswordToggleIcon>
                      }
                      name="confirm_password"
                      value={orgData.confirm_password}
                      onChange={(e) =>
                        handleChange(e.target.value, "confirm_password")
                      }
                      helperText={errors.confirm_password}
                      error={errors.confirm_password}
                      onBlur={(e) => handleBlurFn(e, "confirm_password")}
                    />
                  </Col>
                  <Col sm={12} md={6}>
                    <InputField
                      fullWidth
                      required={true}
                      label="First Name"
                      placeholder="First Name"
                      type="text"
                      name="first_name"
                      value={orgData.first_name}
                      onChange={(e) =>
                        handleChange(e.target.value, "first_name")
                      }
                      helperText={errors.first_name}
                      error={errors.first_name}
                      onBlur={(e) => handleBlurFn(e, "first_name")}
                    />
                  </Col>
                  <Col sm={12} md={6}>
                    <InputField
                      fullWidth
                      required={true}
                      label="Last Name"
                      placeholder="Last Name"
                      type="text"
                      name="last_name"
                      value={orgData.last_name}
                      onChange={(e) =>
                        handleChange(e.target.value, "last_name")
                      }
                      helperText={errors.last_name}
                      error={errors.last_name}
                      onBlur={(e) => handleBlurFn(e, "last_name")}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Flex>
          <Gap height={100} />
          <Flex justifyContent="flex-end" gap={"10"}>
            <Button
              onClick={() => {
                route("/admin/organization-list");
              }}
              variant="outlined"
            >
              Cancle
            </Button>
            <Button color="primary" onClick={() => handleSubmit()} variant="outlined">
              Save & Exit
            </Button>
          </Flex>
        </ContentBody>
      </ContentLayout>
    </>
  );
}
export default AdminOrganizationAdd;
